import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosPost } from './axiosUtils';
import './axiosInterceptor';

const AuditLogService = {
  async fetchLog(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`auditLog/list`, payload);
  },
  async fetchEmailHistoryLog(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`auditLog/emailHistoryList`, payload);
  },
};

export default AuditLogService;
